(function () {
  'use strict';

  // Simple fetch handler for Shopify's AJAX cart API
  // also handles opening/closing the minicart

  // How to use:
  // - this object responds via the event-bus.js system to 'add-to-cart,' 'remove-from-cart,' 'update-cart,' and 'get-cart' events, calling the corresponding endpoint
  // - uses the section bundling in Shopify's AJAX cart API to update the minicart and cart page

  // Path: scripts/cart.js

  // TODOs
  // - eventually, convert this to a custom element? or maybe convert minicart to custom element and pass section data back into the event bus
  //   might not be necessary though
  // - second pass refactor: lots of duplicated code between add, update, clear
  //  -- also consolidate data attribute queries and skip postFetchUpdate subfunctions if the relevant element isn't present, or missing that section in the response data

  class ShopifyCart {
    constructor() {
      this.addEndpoint = '/cart/add.js'; // POST
      this.updateEndpoint = '/cart/update.js'; // POST
      this.clearEndpoint = '/cart/clear.js'; // POST
      this.getEndpoint = '/cart.js'; // GET
      this.sectionList = 'minicart-content,minicart-subtotal,cart-content,cart-subtotal';

      this.cartContent = document.querySelector('[data-cart-content]');
      this.cartSubtotal = this.cartContainer?.querySelector('[data-cart-subtotal]');
      this.cartActions = this.cartContainer?.querySelector('[data-cart-actions]');

      this.minicartContainer = document.querySelector('[data-minicart-container]');
      this.minicartPane = this.minicartContainer?.querySelector('[data-minicart-pane]');
      this.minicartContent = this.minicartContainer?.querySelector('[data-minicart-content]');
      this.minicartActions = this.minicartContainer?.querySelector('[data-minicart-actions]');
      this.minicartSubtotal = this.minicartContainer?.querySelector('[data-minicart-subtotal]');
      this.minicartOpenBackdrop = document.querySelector('[data-minicart-backdrop]');

      window.eventBus.sub('add-to-cart', (data) => this.add(data));
      window.eventBus.sub('update-cart', (data) => this.update(data));
      window.eventBus.sub('clear-cart', () => this.clear());

      // Rebuy Minicart events, yes the object nesting is wack, not my fault, this comes from rebuy
      document.addEventListener('rebuy:cart.add', (event) => { this.postFetchUpdates(event.detail.cart.cart); });
      document.addEventListener('rebuy:cart.change', (event) => { this.postFetchUpdates(event.detail.cart.cart); });
    }

    add(data) {
      const updates = { items: data.detail.items, sections: this.sectionList};
      this.apiCall(this.addEndpoint, updates);
    }

    update(data) {
      const updates = { updates: { [data.detail.key]: data.detail.quantity}, sections: this.sectionList};
      this.apiCall(this.updateEndpoint, updates);
    }

    clear() {
      const updates = { sections: this.sectionList };
      this.apiCall(this.clearEndpoint, updates);
    }

    apiCall(endpoint, updates) {
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      })
        .then(response => response.json())
        .then(data => this.postFetchUpdates(data));
    }

    postFetchUpdates(data) {
      this.updateCartTotal(data);
      // when using a third-party minicart app a la Rebuy, there likely won't be a sections API response or even a need for it (native minicart disabled in those cases)
      if (data.sections) {
        this.updateCartContent(data);
        this.updateMinicartContent(data);
        this.updateMinicartSubtotal(data);
      }
      this.updateMinicartActionVisibility(data);
      this.updateBagIconTotal(data);
      this.updateGiftCheckpointTotal(data);
      this.toggleMinicart();
    }

    updateCartTotal(data) {
      this.cartTotal = data.total_price || data.items.reduce((acc, item) => acc + item.final_line_price, 0);
    }

    updateCartContent(data) {
      if (!this.cartContent || !data.sections['cart-content']) return
      this.cartContent.innerHTML = data.sections['cart-content'];
    }

    updateMinicartContent(data) {
      if (!this.minicartContent || !data.sections['minicart-content']) return
      this.minicartContent.innerHTML = data.sections['minicart-content'];
    }

    updateMinicartSubtotal(data) {
      if (!this.minicartSubtotal || !data.sections['minicart-subtotal']) return
      if (data.items.length === 0) return
      this.minicartSubtotal.innerHTML = data.sections['minicart-subtotal'];
    }

    updateMinicartActionVisibility(data) {
      if (!this.minicartActions) return
      if (data.items.length === 0) {
        this.minicartActions?.classList.add('hidden');
      } else {
        this.minicartActions?.classList.remove('hidden');
      }
    }

    updateBagIconTotal(data) {
      const cartCount = document.querySelector("[data-cart-count]");
      const hiddenCartCount = document.querySelector("[data-cart-count-hidden]");
      if (cartCount) {
        cartCount.innerHTML = data.item_count > 0 ? data.item_count : '';
        cartCount.style.display = data.item_count > 0 ? 'flex' : 'none';
      }
      if (hiddenCartCount) {
        hiddenCartCount.innerHTML = data.item_count > 0 ? `${data.item_count} items in cart` : '';
        hiddenCartCount.style.display = data.item_count > 0 ? 'flex' : 'none';
      }
    }

    // for now, just directly update the cart total on the gift checkpoint element, if present, rather than move bar into a section
    updateGiftCheckpointTotal(data) {
      const chkpt = document.querySelector("minicart-gift-checkpoints");
      if (chkpt) {
        chkpt.setAttribute("cart-total", this.cartTotal);
      }
    }

    toggleMinicart() {
      if (!this.minicartPane) return
      if (this.minicartPane.classList.contains('active')) return // don't toggle if already open, i.e. adding from free sample or recommended
      window.eventBus.pub('toggle-minicart');
    }
  }

  window.cart = new ShopifyCart();

})();
